export class SubscriptionGiftController {
  constructor($scope, $rootScope, GiftService) {
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.GiftService = GiftService;
    this.scope.birthdayGift = false;
    this.scope.lastVisitGift = false;

    this.scope.show = {
      success: false,
      error: false
    };

    this.init();
  }

  init() {
    this.scope.updateView = () => {
      this.scope.show.success = this.scope.birthdayGift || this.scope.lastVisitGift || this.scope.lastActive || this.scope.easterGift;
      this.scope.show.error = !this.scope.show.success;
    };

    async.parallel([
      (callback) => {
        this.GiftService.getBirthday()
        .then((response) => { let data = response.data;
          this.scope.birthdayGift = data.success;
          callback();
        })
        .catch((response) => { let err = response.data;
          callback(err);
        });
      },

      (callback) => {
        this.GiftService.getLastVisit()
        .then((response) => { let data = response.data;
          this.scope.lastVisitGift = data.success;
          callback();
        })
        .catch((response) => { let err = response.data;
          callback(err);
        });
      },

      (callback) => {
        this.GiftService.getLastActive()
        .then((response) => { let data = response.data;
          this.scope.lastActive = data.success;
          callback();
        })
        .catch((response) => { let err = response.data;
          callback(err);
        });
      },

      (callback) => {
        this.GiftService.getBoost()
            .then((response) => { let data = response.data;
              this.scope.lastActive = data.success;
              callback();
            })
            .catch((response) => { let err = response.data;
              callback(err);
            });
      },

      (callback) => {
        this.GiftService.getEaster()
            .then((response) => { let data = response.data;
              this.scope.easterGift = data.success;
              callback();
            })
            .catch((response) => { let err = response.data;
              callback(err);
            });
      }
    ], (err) => {
      if(err) {
        console.error(err);
      } else {
        this.rootScope.getCurrentUser();
      }

      this.scope.updateView();
    });
  }
}
